import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { PHONE_DISPLAY } from "@/data";
import { track } from "@/hooks/useAnalytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { name: "", email: "", phone: "", message: "" };

const inputCls =
  "w-full rounded-xl border border-white/15 bg-forest/60 px-4 py-3.5 font-sans text-sm text-cream placeholder:text-mist/50 outline-none transition-[border-color] duration-300 focus:border-leaf";

export const EnquiryForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [treatment, setTreatment] = useState("");
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const message = treatment ? `Treatment: ${treatment}\n\n${form.message}` : form.message;
      const res = await axios.post(`${API}/contact`, { ...form, message });
      toast.success(res.data.message || "Got it — we'll get back to you soon.");
      track("enquiry_submit", { treatment: treatment || "none" });
      setForm(EMPTY);
      setTreatment("");
    } catch {
      toast.error(`That didn't go through, sorry. Give us a ring on ${PHONE_DISPLAY}.`);
    } finally {
      setSending(false);
    }
  };

  return (
    <form data-testid="contact-enquiry-form" onSubmit={submit} className="rounded-2xl border border-leaf/15 bg-pine p-8 sm:p-10">
      <p className="font-mono text-xs tracking-[0.25em] uppercase text-leaf">Rather we called you back?</p>
      <h3 className="mt-2 font-serif text-2xl text-cream">Drop us a line</h3>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <input required data-testid="contact-form-name" placeholder="Your name" value={form.name} onChange={set("name")} className={inputCls} />
        <input required type="email" data-testid="contact-form-email" placeholder="Email" value={form.email} onChange={set("email")} className={inputCls} />
        <input data-testid="contact-form-phone" placeholder="Mobile (optional)" value={form.phone} onChange={set("phone")} className={inputCls} />
        <input data-testid="contact-form-treatment" placeholder="What's it about? (optional)" value={treatment} onChange={(e) => setTreatment(e.target.value)} className={inputCls} />
        <textarea
          required
          rows={4}
          data-testid="contact-form-message"
          placeholder="Tell us a bit about what's going on — or just say hi"
          value={form.message}
          onChange={set("message")}
          className={`${inputCls} sm:col-span-2`}
        />
      </div>
      <button
        type="submit"
        disabled={sending}
        data-testid="contact-form-submit-button"
        className="mt-6 inline-flex items-center gap-2 rounded-md bg-cream px-7 py-3.5 font-sans font-medium text-forest transition-[background-color,box-shadow] duration-300 hover:bg-sage hover:shadow-[0_12px_40px_-8px_rgba(36,54,47,0.5)] disabled:opacity-60"
      >
        {sending ? "Sending…" : "Send it through"}
      </button>
    </form>
  );
};
